import { apiFirst } from '@/core/api/resources'

export type Zeitraum = { beginn: string | null; ende: string | null }

export async function letzterVergabeZeitraum(): Promise<Zeitraum | null> {
  const neueste = await apiFirst('/teilnahme', {
    order: 'created_at',
    desc: true,
    limit: 1,
  })
  return neueste?.variant === 'vergabe' ? { beginn: neueste.beginn, ende: neueste.ende } : null
}
